import { NewDashboardComponent } from './newDashboard';
import 'angular-daterangepicker';

export default angular.module('dbm.dashboard', [])
    .component('newDashboard', NewDashboardComponent)



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/index.js